import { Injectable } from '@angular/core';
import { IConfig } from 'web-api-client/src/public-api';
import { Router } from '@angular/router';
import { KiaExampleClient } from 'web-api-client/src/lib/generated/kia-example-api-client';
import { KiaAuthenticationClient } from 'web-api-client/src/lib/generated/kia-authentication-api-client';
import { KiaPageClient } from 'web-api-client/src/lib/generated/kia-pages-api-client';
import { KiaUserClient } from 'web-api-client/src/lib/generated/kia-users-api-client';
import { KiaProjectsClient } from 'web-api-client/src/lib/generated/kia-projects-api-client';
import { KiaLessonsClient } from 'web-api-client/src/lib/generated/kia-lessons-api-client';
import { KiaCountryClient } from 'web-api-client/src/lib/generated/kia-countries-api-client';
import { KiaQuizzesClient } from 'web-api-client/src/lib/generated/kia-quizzes-api-client';
import { environment } from 'src/environments/environment';
import { KiaTroubleshootingDetailsClient } from 'web-api-client/src/lib/generated/kia-troubleshooting-details-api-client';
import { KiaSitesClient } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-sites-api-client';

@Injectable({
  providedIn: 'root',
})
export class APIService {
  constructor(private router: Router) { }

  private authLocalStorageToken = `auth`;

  getKiaExampleApiClient(): KiaExampleClient {
    const config = new IConfig();
    config.authenticationToken = 'test';
    config.router = this.router;

    return new KiaExampleClient(config);
  }

  getKiaAuthenticationApiClient(): KiaAuthenticationClient {
    return new KiaAuthenticationClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaProjectsClient(): KiaProjectsClient {
    return new KiaProjectsClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaLessonsClient(): KiaLessonsClient {
    return new KiaLessonsClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaPageClient(): KiaPageClient {
    return new KiaPageClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaPageClientNoAuth(token: string): KiaPageClient {
    return new KiaPageClient(<IConfig>{
      authenticationToken: token
    }, environment.apiUrl);
  }

  getKiaUserApiClient(): KiaUserClient {
    return new KiaUserClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaCountriesAPIClient(): KiaCountryClient {
    return new KiaCountryClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaSitesApiClient(): KiaSitesClient {
    return new KiaSitesClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaQuizzesAPIClient(): KiaQuizzesClient {
    return new KiaQuizzesClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaTroubleshootingAPIClient(): KiaTroubleshootingDetailsClient {
    return new KiaTroubleshootingDetailsClient(this.getApiConfig(), environment.apiUrl);
  }

  getKiaTroubleshootingAPIClientNoAuth(token: string): KiaTroubleshootingDetailsClient {
    return new KiaTroubleshootingDetailsClient(<IConfig>{
      authenticationToken: token
    }, environment.apiUrl);
  }

  private getApiConfig(): IConfig {
    return <IConfig>{
      authenticationToken: this.getAuth(),
      router: this.router
    };
  }

  public setAuth(auth: string): boolean {
    if (auth) {
      localStorage.setItem(this.authLocalStorageToken, auth);
      return true;
    }
    return false;
  }


  public setLoggedInUserEmail(email: string): boolean {
    if (email) {
      localStorage.setItem('emailAddress', email);
      return true;
    }
    return false;
  }

  public setLoggedInUserName(name: string): boolean {
    if (name) {
      localStorage.setItem('fullName', name);
      return true;
    }
    return false;
  }

  public getAuth(): string {
    try {
      const authData = localStorage.getItem(this.authLocalStorageToken)!;
      return authData;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  public clearAuth() {
    localStorage.setItem(this.authLocalStorageToken, '');
    localStorage.setItem('emailAddress', '');
    localStorage.setItem('fullName', '');
    localStorage.setItem('role', '');
  }
}
